// @flow
import { NotificationType } from "bb-betslip";
/**
 * Translations for error messages returned by the Pricing API
 * @type {{
 *  EVENT_STARTED: {title: string, message: string, type: string},
 *  HANDICAP_CHANGED: {title: string, message: string, type: string},
 *  GENERIC: {title: string, message: null, type: string},
 *  EVENT_SUSPENDED: {title: string, message: string, type: string}
 * }}
 */
export const PricingError = {
  GENERIC: {
    title: "GENERIC_TITLE",
    message: "GENERIC_MESSAGE",
    type: NotificationType.Warning
  },
  EVENT_STARTED: {
    title: "EVENT_STARTED_TITLE",
    message: "EVENT_STARTED_MESSAGE",
    type: NotificationType.Warning
  },
  EVENT_SUSPENDED: {
    title: "EVENT_SUSPENDED_TITLE",
    message: "EVENT_SUSPENDED_MESSAGE",
    type: NotificationType.Warning
  },
  HANDICAP_CHANGED: {
    title: "HANDICAP_CHANGED_TITLE",
    message: "HANDICAP_CHANGED_MESSAGE",
    type: NotificationType.Warning
  },
  INVALID_DATA: {
    title: "INVALID_DATA_TITLE",
    message: "INVALID_DATA_MESSAGE",
    type: NotificationType.Warning
  },
  OUTCOME_SUSPENDED: {
    title: "OUTCOME_SUSPENDED_TITLE",
    message: "OUTCOME_SUSPENDED_MESSAGE",
    type: NotificationType.Warning
  },
  BET_NO_PRICE_OFFER: {
    title: "BET_NO_PRICE_OFFER_TITLE",
    message: "BET_NO_PRICE_OFFER_MESSAGE",
    type: NotificationType.Passive
  },
  BET_PRICING_NOT_AVAILABLE: {
    title: "BET_PRICING_NOT_AVAILABLE_TITLE",
    message: "BET_PRICING_NOT_AVAILABLE_MESSAGE",
    type: NotificationType.Warning
  },
  NON_COMBINABLE_OUTCOMES: {
    title: "NON_COMBINABLE_OUTCOMES_TITLE",
    message: "NON_COMBINABLE_OUTCOMES_MESSAGE",
    type: NotificationType.Warning
  },
  BET_PRICING_NOT_POSSIBLE: {
    title: "BET_PRICING_NOT_POSSIBLE_TITLE",
    message: "BET_PRICING_NOT_POSSIBLE_MESSAGE",
    type: NotificationType.Warning
  },
  BET_PRICE_NOT_AVAILABLE: {
    title: "BET_PRICE_NOT_AVAILABLE_TITLE",
    message: "BET_PRICE_NOT_AVAILABLE_MESSAGE",
    type: NotificationType.Warning
  },

  // BUILD_ERROR: {
  //   title: "BUILD_ERROR_TITLE",
  //   message: "BUILD_ERROR_MESSAGE",
  //   type: NotificationType.Warning
  // }
};

/**
 * Convenience method for returning Pricing Errors
 *
 * @param key
 * @returns {PricingError.GENERIC|{title, message, type}|*}
 */
export const errorForKey = (key?: string) => {
  console.log("error", key);
  if(key == null) return PricingError.GENERIC;
  const error = PricingError[key];
  if(error == null) return  PricingError.GENERIC;
  return error;
};





// WEBPACK FOOTER //
// ./src/errors/pricingError.js